var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 296,
    height: 320,
    viewBox: "0 0 296 320",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.1676 130.588C72.9206 130.588 59.7559 143.753 59.7559 160C59.7559 176.247 72.9206 189.412 89.1676 189.412H147.991C164.238 189.412 177.403 176.247 177.403 160C177.403 143.753 164.238 130.588 147.991 130.588H89.1676Z",
    fill: "#181832"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M206.815 118.824C223.062 118.824 236.227 105.659 236.227 89.4118C236.227 73.1647 223.062 60 206.815 60H89.1676C72.9206 60 59.7559 73.1647 59.7559 89.4118C59.7559 105.659 72.9206 118.824 89.1676 118.824H206.815Z",
    fill: "#181832"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7559 260C106.324 260 119.756 246.569 119.756 230C119.756 213.431 106.324 200 89.7559 200C73.1873 200 59.7559 213.431 59.7559 230C59.7559 246.569 73.1873 260 89.7559 260Z",
    fill: "#181832"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmall);
export default __webpack_public_path__ + "static/media/logo_small.a675c48df2cc7f742a1bff30a4922dc6.svg";
export { ForwardRef as ReactComponent };